import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useApi } from '../use-api';
import { api, CatalogGrade } from '../api';
import { Layout, Loading, ErrorBox } from '../components/Layout';

export function Subjects() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data, error, loading } = useApi<CatalogGrade[]>(() => api.catalog(), []);
  const grade = data?.find((g) => g.id === id);

  return (
    <Layout>
      {loading && <Loading />}
      {error && <ErrorBox message={error} />}
      {data && !grade && <ErrorBox message={t('common.error')} />}
      {grade && (
        <>
          <Link to="/" className="text-sm text-sky-700 hover:underline">
            ← {t('nav.home')}
          </Link>
          <h1 className="text-2xl font-semibold text-slate-900 mt-2 mb-4">{grade.name}</h1>
          <div className="space-y-6">
            {grade.subjects.map((s) => (
              <section key={s.id}>
                <h2 className="font-medium text-slate-700 mb-2">{s.name}</h2>
                <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                  {s.books.map((b) => (
                    <Link
                      key={b.id}
                      to={`/book/${b.id}`}
                      className="block rounded-xl bg-white border border-slate-200 p-4 hover:border-sky-400 hover:shadow-sm transition"
                    >
                      <div className="font-medium text-slate-900">{b.title}</div>
                      <div className="text-sm text-slate-500 mt-1">
                        {t('book.videos', { count: b.videoCount })}
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </>
      )}
    </Layout>
  );
}
